
import { MeasurementPoint } from "@/components/Measurements/Types/MeasurementGroups";
import { createContext } from "react";

export const MeasurementContext = createContext<{
    selectedMeasurement: MeasurementPoint | null,
    groupId: number | null,
    selectMeasurement: (measurementPoint: MeasurementPoint | null) => void,
    setGroupId: (groupId: number) => void,
}>({
    selectedMeasurement: null,
    groupId: null,
    selectMeasurement: () => { },
    setGroupId: () => { },
});

export const MeasurementProvider = MeasurementContext.Provider;
export const MeasurementConsumer = MeasurementContext.Consumer;